import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  PhoneOutlined,
  MenuOutlined,
  CloseOutlined,
  MailOutlined,
  EnvironmentOutlined,
  FacebookFilled,
  InstagramFilled
} from '@ant-design/icons';
import { APP_URLS } from '../../config/appConfig';
import './Layout.css';
import './Footer.css';
import './Header.css';

function Layout({ children, showHero = false }) {
  const history = useHistory();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeNav, setActiveNav] = useState('accueil');

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
    return () => document.body.classList.remove('mobile-menu-open');
  }, [mobileMenuOpen]);

  useEffect(() => {
    const mq = () => window.innerWidth <= 900;
    const set = () => setIsMobile(mq());
    set();
    window.addEventListener('resize', set);
    return () => window.removeEventListener('resize', set);
  }, []);

  const scrollToSection = (sectionId) => {
    // If we're not on the home page, navigate there first
    if (window.location.pathname !== '/') {
      history.push('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
    setMobileMenuOpen(false);
    setActiveNav(sectionId);
  };

  const navigateToHome = () => {
    history.push('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="layout-wrapper">
      {/* Header */}
      <header className="batilink-header">
        <div className="container">
          <div className="header-content">
            <div onClick={navigateToHome} style={{ cursor: 'pointer' }}>
              <div style={{
                fontWeight: 700,
                fontSize: 32,
                letterSpacing: 2,
                textAlign: 'center',
                textTransform: 'uppercase',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0,
                width: '100%'
              }}>
                <span style={{ color: "#222", fontWeight: 700, fontFamily: "Bruno Ace SC, sans-serif" }}>BATI</span>
                <span style={{ color: "#FFF", fontWeight: 700, fontFamily: "Bruno Ace SC, sans-serif" }}>LINK</span>
              </div>
            </div>
            
            <nav className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <a href="#accueil" className={activeNav === 'accueil' ? 'active' : ''} onClick={(e) => { e.preventDefault(); scrollToSection('accueil'); }}>Accueil</a>
              <a href="/recherche" className={activeNav === 'professionnels' ? 'active' : ''} onClick={(e) => { e.preventDefault(); setMobileMenuOpen(false); setActiveNav('professionnels'); history.push('/recherche'); }}>Professionnels</a>
              {/* <a href="#services" className={activeNav === 'services' ? 'active' : ''} onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a> */}
              <a href="#app-mobile" className={activeNav === 'app-mobile' ? 'active' : ''} onClick={(e) => { e.preventDefault(); scrollToSection('app-mobile'); }}>App Mobile</a>
              <a href="#contact" className={activeNav === 'contact' ? 'active' : ''} onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a>

              {isMobile && (
                <>
                  <button
                    className="signin-btn nav-signin"
                    onClick={() => { setMobileMenuOpen(false); window.location.href = APP_URLS.FLUTTER_WEB_APP; }}
                  >
                    Connexion
                  </button>
                  <button
                    className="signin-btn nav-signin"
                    onClick={() => { setMobileMenuOpen(false); history.push('/sign-in'); }}
                  >
                    Espace Partenaire
                  </button>
                </>
              )}
            </nav>

            <div className="header-actions">
              <button 
                className="signin-btn"
                onClick={() => window.location.href = APP_URLS.FLUTTER_WEB_APP}
              >
                Connexion
              </button>
              {!isMobile && (
                <button 
                  className="signin-btn"
                  onClick={() => history.push('/sign-in')}
                >
                  Espace Partenaire
                </button>
              )}
              <button 
                className="mobile-menu-toggle"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                {mobileMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="layout-main">
        {children}
      </main>

      {/* Footer */}
  <footer className="bl-footer" id="footer-contact">
        <div className="container">
          <div className="bl-footer-grid">
            {/* Marque + tagline + réseaux sociaux */}
            <div className="bl-footer-brand">
              <div className="bl-footer-logo">
                <span className="bl-footer-logo-text"><span className="y">BATILINK</span></span>
              </div>
              <p className="bl-footer-tagline">
                La meilleure plateforme pour trouver les meilleurs professionnels du BTP en Tunisie.
              </p>
              <div className="bl-footer-socials">
                <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="bl-footer-social" aria-label="Facebook"><FacebookFilled /></a>
                <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="bl-footer-social" aria-label="Instagram"><InstagramFilled /></a>
              </div>
            </div>

            {/* Contact */}
            <div className="bl-footer-col">
              <h4 className="bl-footer-title">Contact</h4>
              <ul className="bl-footer-contact">
                <li><MailOutlined className="bl-footer-ic" /><span>contact@batilink.tn</span></li>
                <li><PhoneOutlined className="bl-footer-ic" /><span>(+216) 36 722 922</span></li>
                <li><EnvironmentOutlined className="bl-footer-ic" /><span>Imm. Avicenne en face hôpital Farhat Hached, Bureau N° B801, Sousse</span></li>
              </ul>
            </div>

            {/* Pour les Clients */}
            <div className="bl-footer-col">
              <h4 className="bl-footer-title">Pour les Clients</h4>
              <ul className="bl-footer-links">
                <li><a href="/recherche" onClick={(e) => { e.preventDefault(); setActiveNav('professionnels'); history.push('/recherche'); }}>Trouver des Professionnels</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Parcourir les Services</a></li>
                <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a></li>
              </ul>
            </div>

            {/* À Propos */}
            <div className="bl-footer-col">
              <h4 className="bl-footer-title">À Propos</h4>
              <ul className="bl-footer-links">
                <li><a href="/about-us" onClick={(e) => { e.preventDefault(); setMobileMenuOpen(false); history.push('/about-us'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Qui Sommes-Nous ?</a></li>
                <li><a href="#promos" onClick={(e) => { e.preventDefault(); scrollToSection('promos'); }}>Promos</a></li>
                <li><a href="#sponsors" onClick={(e) => { e.preventDefault(); scrollToSection('sponsors'); }}>Nos Sponsors</a></li>
                <li><a href="/politique-confidentialite">Politique de Confidentialité</a></li>
              </ul>
            </div>
          </div>

          <div className="bl-footer-bottom">
            <p>&copy; 2025 BATILINK. Tous droits réservés.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
